import { Box, ResponsiveContext, Text } from "grommet";
import * as React from "react";
import { Route, Routes, useLocation } from "react-router-dom";
import { useUser } from "../account/AccountStore";
import BillingManagement from "../admin/BillingManagement";
import BadgesManagement from "../badges/BadgesManagement";
import { useDarkMode } from "../components/DarkModeSwitch";
import SkeletonWrapper from "../components/SkeletonWrapper";
import ContentManagement from "../content/ContentManagement";
import DiscordServerManagement from "../discord/DiscordServerManagement";
import StatsManagement from "../stats/StatsManagement";
import AdminNavigation from "./AdminNavigation";
import MapsManagement from "../maps/MapsManagement";
import GamesManagement from "../games/GamesManagement";
import AgentsManagement from "../agents/AgentsManagement";

const ManagementHome = () => {
    let user = useUser();

    React.useEffect(() => {
        if (user.isAuthenticated) {
            setLoading(false);
        }
        if (user.resolved && !user.isAuthenticated) {
            window.location.href = "/account/signin?redirectUrl=" + window.location.pathname;
        }
    }, [user]);

    const size = React.useContext(ResponsiveContext);
    const { pathname } = useLocation();
    const [pageSize, setPageSize] = React.useState(size == "small" ? "small" : "medium");

    const [loading, setLoading] = React.useState(true);

    React.useEffect(() => {
        if (pathname.indexOf("bracket") >= 0) {
            setPageSize("100%");
        } else {
            setPageSize(size == "small" ? "100%" : "80%");
        }
    }, [pathname]);

    return (
        <SkeletonWrapper loading={loading} count={5}>
            <Box align={size != "small" ? "center" : ""}>
                {user.hasRole("Admin") && (
                    <Box>
                        <AdminNavigation></AdminNavigation>
                        <Routes>
                            <Route path="/stats/*" element={<StatsManagement />}></Route>
                            <Route path="/billing/*" element={<BillingManagement />}></Route>
                            <Route path="/discord/*" element={<DiscordServerManagement />}></Route>
                            <Route path="/content/*" element={<ContentManagement />}></Route>
                            <Route path="/badges/*" element={<BadgesManagement />}></Route>
                            <Route path="/maps/*" element={<MapsManagement />}></Route>
                            <Route path="/games/*" element={<GamesManagement />}></Route>
                            <Route path="/agents/*" element={<AgentsManagement />}></Route>
                        </Routes>
                    </Box>
                )}
                {!user.hasRole("Admin") && <Text>You do not have permissions to view this page</Text>}
            </Box>
        </SkeletonWrapper>
    );
};

export default ManagementHome;
